/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Ecosystem_TitleInputs */

const en_home_ecosystem_title = /** @type {(inputs: Home_Ecosystem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At home in the tools you already open every morning.`)
};

const lv_home_ecosystem_title = /** @type {(inputs: Home_Ecosystem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēma iederas rīkos, kurus atverat katru rītu.`)
};

/**
* | output |
* | --- |
* | "At home in the tools you already open every morning." |
*
* @param {Home_Ecosystem_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_ecosystem_title = /** @type {((inputs?: Home_Ecosystem_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Ecosystem_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_ecosystem_title(inputs)
	return en_home_ecosystem_title(inputs)
});